import WizardBody from "./WizardBody";
export default WizardBody;
